import { useMemo } from "react";
import { withQueryParams } from "../../appointment-details/helpers/common.js";
import { useAnamnesisSSE } from "../../../../hooks/sse/useAnamnesisSSE.js";
import { useAppointmentSSE } from "../../../../hooks/sse/useAppointmentSSE.js";
import { useServerSentEvent } from "../../../../hooks/useServerSentEvent.js";
import { ServerSentResourceType } from "../../../../type/InternalServerSentEvents.js";
import { usePatientSSE } from "../../../../hooks/sse/usePatientSSE.js";
import { useCodeSSE } from "../../../../hooks/sse/useCodeSSE.js";
import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../components/AxiosProvider.js";
import "date-fns";
import "date-fns/locale";
import "../../appointment-details/appointment-details.types.js";
import "../../../../constants/serverSentEvents/serverSentEvents.js";
import "react/jsx-runtime";
import "axios";
const getPatientTodayList = (axios) => async (params, signal) => {
  const { data = [] } = await axios.get("/api/appointments/daily", {
    signal,
    params
  });
  return data;
};
const usePatientTodayList = (enabled, params) => {
  const { calmaster } = useAxiosProvider();
  const queryKey = useMemo(() => ["patient-today-list", params], [params]);
  const { data, ...queryResult } = useQuery({
    queryKey,
    queryFn: withQueryParams(getPatientTodayList(calmaster)),
    enabled,
    keepPreviousData: true
  });
  const handleRefetch = () => {
    queryResult.refetch();
  };
  useAppointmentSSE(handleRefetch);
  useAnamnesisSSE(handleRefetch);
  usePatientSSE(handleRefetch);
  useCodeSSE(handleRefetch);
  useServerSentEvent(ServerSentResourceType.PATIENT_CREDITWORTHINESS, "UPDATED", handleRefetch);
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  usePatientTodayList
};
